import { ApiService } from '../../../services/api.service';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
var BillingListComponent = (function () {
    function BillingListComponent(apiService, translate) {
        this.apiService = apiService;
        this.translate = translate;
        this.itemsPerPage = 10;
        this.monthListDropdown = [];
        this.yearList = [];
        this.list = [];
        this.currentPage = 1;
        this.loading = false;
        this.title = '';
        this.selectedDuplictedData = false;
        this.includeInB2POnly = false;
        this.loading_excel_report = false;
    }
    BillingListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadTexts();
        this.populateDropdown();
        this.loadData();
        this.translate.onLangChange.subscribe(function (event) {
            _this.loadTexts();
        });
    };
    BillingListComponent.prototype.loadTexts = function () {
        var _this = this;
        this.monthListDropdown = [];
        this.translate.get('COMMON.ALL').subscribe(function () {
            _this.monthListDropdown.push({ label: _this.translate.instant('MONTH.JANUARY'), value: 1 }, { label: _this.translate.instant('MONTH.FEBRUARY'), value: 2 }, { label: _this.translate.instant('MONTH.MARCH'), value: 3 }, { label: _this.translate.instant('MONTH.APRIL'), value: 4 }, { label: _this.translate.instant('MONTH.MAY'), value: 5 }, { label: _this.translate.instant('MONTH.JUNE'), value: 6 }, { label: _this.translate.instant('MONTH.JULY'), value: 7 }, { label: _this.translate.instant('MONTH.AUGUST'), value: 8 }, { label: _this.translate.instant('MONTH.SEPTEMBER'), value: 9 }, { label: _this.translate.instant('MONTH.OCTOBER'), value: 10 }, { label: _this.translate.instant('MONTH.NOVEMBER'), value: 11 }, { label: _this.translate.instant('MONTH.DECEMBER'), value: 12 });
        });
    };
    BillingListComponent.prototype.populateDropdown = function () {
        var currentDate = new Date();
        // populate year list back within 10 years
        var thisYear = currentDate.getFullYear();
        for (var i = 0; i <= 10; i++) {
            this.yearList.push({ label: (thisYear - i).toString(), value: thisYear - i });
        }
        // set current month and year
        this.selectedMonth = currentDate.getMonth() + 1;
        this.selectedYear = thisYear;
    };
    // search() {
    //   if (this.currentPage != 1) {
    //     this.currentPage = 1;
    //     this.pageChanged();
    //   }
    //   else {
    //     this.pageChanged();
    //   }
    // }
    BillingListComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.loadData(params);
    };
    BillingListComponent.prototype.search = function () {
        this.currentPage = 1;
        this.loadData();
    };
    BillingListComponent.prototype.loadData = function (params) {
        var _this = this;
        var data = {
            month: this.selectedMonth,
            year: this.selectedYear,
            duplicate_only: this.selectedDuplictedData,
            included_in_b2p_only: this.includeInB2POnly
        };
        this.title = '';
        this.loading = true;
        this.apiService.sign_counter(data, params).subscribe(function (res) {
            _this.list = res.results;
            _this.totalItems = res.count;
            // this.title = "พบการลงลายมือชื่อดิจิทัลทั้งหมด " + this.totalItems.toLocaleString() + " ครั้ง";
            _this.loading = false;
        });
    };
    BillingListComponent.prototype.clearSearch = function () {
        var currentDate = new Date();
        // set current month and year
        this.selectedMonth = currentDate.getMonth() + 1;
        this.selectedYear = currentDate.getFullYear();
        this.selectedDuplictedData = false;
        this.search();
    };
    BillingListComponent.prototype.humanFileSize = function (size) {
        var i = Math.floor(Math.log(size) / Math.log(1024));
        return (size / Math.pow(1024, i)).toFixed(0) + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
    };
    ;
    BillingListComponent.prototype.DownloadExcelReport = function () {
        var _this = this;
        this.loading_excel_report = true;
        var params = {
            month: this.selectedMonth,
            year: this.selectedYear,
            duplicate_only: this.selectedDuplictedData,
            included_in_b2p_only: this.includeInB2POnly
        };
        this.apiService.getBillingExcelReport(params).subscribe(function (obj) {
            var filename = 'billing_report_' + _this.selectedMonth + '_' + _this.selectedYear + '.csv';
            _this.apiService.createDownloadFile(obj, filename);
            _this.loading_excel_report = false;
        }, function (error) {
            _this.loading_excel_report = false;
        });
    };
    return BillingListComponent;
}());
export { BillingListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/billing/billing-list/billing-list.component.ts.pre-build-optimizer.js